export default {"src":"/_next/static/media/B2BSeamlessCorporateGifting.93aa572c.svg","height":228,"width":404,"blurWidth":0,"blurHeight":0};